import { Feedback, TypeArray, JumpType } from "../types"
import { reducerTypeGuard } from "../reducers/reducerGuards"
import { actionCreatorTypeGuard } from "../reducers/actionCreators"

export type Jump = {
  type: JumpType
  id: string
}

const reducerAction = {
  type: actionCreatorTypeGuard<Jump, JumpType>("type", "Jump"),
  id: actionCreatorTypeGuard<Jump, string>("id", "Jump"),
  __record: actionCreatorTypeGuard<TypeArray, Jump>("Jump", "__record"),
  __create: actionCreatorTypeGuard<TypeArray, null | Partial<Jump>>(
    "create",
    "__create/Jump"
  ),
  __null: actionCreatorTypeGuard<TypeArray, null>("null", "__record")
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in
    | keyof Jump
    | "__record"
    | "__null"
    | "__create"]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const jumpAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const jumpReducer = reducerTypeGuard<Jump>()
  .case(...reducerAction.id)
  .case(...reducerAction.type)
  .build()
